import { Button, Group, Input, Loader, Modal } from '@mantine/core';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { notifications } from '@mantine/notifications';
import { myFetch } from '@commons/fetch';

export const RenameModal = ({
  model,
  onClose,
}: {
  model: any;
  onClose: (response: any) => void;
}) => {
  const intl = useIntl();
  const [isRenaming, setIsRenaming] = useState<boolean>(false);
  const [newName, setNewName] = useState<string>(model.name);

  const handleRename = async () => {
    try {
      setIsRenaming(true);

      const response = await myFetch(`/${model.owner}/models/${model.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          name: newName,
        }),
      });

      notifications.show({
        color: 'green',
        title: intl.formatMessage({ id: 'success' }),
        message: intl.formatMessage({ id: 'renamedModel' }, { name: newName }),
      });

      onClose(response);
    } catch (err: any) {
      notifications.show({
        color: 'red',
        title: intl.formatMessage({ id: 'error' }),
        message: err?.message || intl.formatMessage({ id: 'error' }),
      });
    } finally {
      setIsRenaming(false);
    }
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'rename' })}
      size="lg"
      centered
      withCloseButton={!isRenaming}
      opened={model !== null}
      onClose={() => onClose(null)}
      closeOnClickOutside={!isRenaming}
      closeOnEscape={!isRenaming}
    >
      <Input
        placeholder="New name"
        value={newName}
        onChange={(e) => setNewName(e.currentTarget.value)}
        disabled={isRenaming}
      />

      <Group mt="lg" justify="flex-end">
        <Button
          disabled={isRenaming}
          onClick={() => onClose(null)}
          variant="default"
        >
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          leftSection={isRenaming ? <Loader size="xs" /> : undefined}
          disabled={isRenaming || !newName.trim()}
          onClick={handleRename}
        >
          {intl.formatMessage({ id: 'rename' })}
        </Button>
      </Group>
    </Modal>
  );
};
